/** Mirrors {@code Constants.MertonRisk} on the backend — risk band is derived from PD_percent. */
export const MERTON_RISK_BANDS = [
  {
    label: 'Very Safe',
    range: 'Below 0.5%',
    categoryKey: 'VERY_SAFE',
    description: 'Minimal estimated default likelihood',
  },
  {
    label: 'Low Risk',
    range: '0.5% – 2%',
    categoryKey: 'LOW_RISK',
    description: 'Comfortable market-implied cushion',
  },
  {
    label: 'Moderate Risk',
    range: '2% – 5%',
    categoryKey: 'MODERATE_RISK',
    description: 'Worth monitoring alongside agency ratings',
  },
  {
    label: 'High Risk',
    range: '5% – 15%',
    categoryKey: 'HIGH_RISK',
    description: 'Higher estimated default risk',
  },
  {
    label: 'Very High Risk',
    range: '15% – 30%',
    categoryKey: 'VERY_HIGH_RISK',
    description: 'Significant default concern',
  },
  {
    label: 'Distressed',
    range: 'Above 30%',
    categoryKey: 'DISTRESSED',
    description: 'Severe estimated default risk',
  },
];

export function resolveRiskBandFromPd(pdPercent) {
  const pd = Number(pdPercent);
  if (Number.isNaN(pd) || pd < 0) return null;
  if (pd < 0.5) return MERTON_RISK_BANDS[0];
  if (pd < 2) return MERTON_RISK_BANDS[1];
  if (pd < 5) return MERTON_RISK_BANDS[2];
  if (pd < 15) return MERTON_RISK_BANDS[3];
  if (pd < 30) return MERTON_RISK_BANDS[4];
  return MERTON_RISK_BANDS[5];
}

/** Prefer PD-derived band for display — stays in sync even if DB risk column is stale. */
export function getDisplayRiskLabel(item) {
  const band = resolveRiskBandFromPd(item?.PD_percent ?? item?.pdPercent);
  return band?.label || item?.risk || 'N/A';
}

export function getDisplayRiskRange(item) {
  const band = resolveRiskBandFromPd(item?.PD_percent ?? item?.pdPercent);
  return band?.range || item?.riskRange || 'N/A';
}
